/**
 * Determines wind favorability for a blind/stand based on current wind direction
 * and the user-configured ideal wind directions.
 *
 * Returns:
 *   'favorable'   — current wind is within the ideal directions list
 *   'unfavorable' — current wind is known but outside the ideal list
 *   'unknown'     — current wind is not available (undefined/empty)
 */
export type WindFavorability = 'favorable' | 'unfavorable' | 'unknown';

export function isWindFavorable(
  current: string | undefined,
  ideal: string[],
): WindFavorability {
  if (!current || current.trim() === '') return 'unknown';
  if (ideal.length === 0) return 'unknown';
  return ideal.includes(current.trim().toUpperCase()) ? 'favorable' : 'unfavorable';
}
